<div (click)="onClick($event)"
    matTooltip="{{ 'Devices' + (showBadge && this.num ? ': ' + this.num : '') }}">

    <button mat-button [color]="active ? buttonActive : ''">
        <!-- <mat-icon [ngClass]="showLabel ? '' : 'noLabel'"
            [matBadge]="num"
            [matBadgeColor]="badgeColour"
            [matBadgePosition]="badgePosition"
            [matBadgeSize]="badgeSize"
            [matBadgeHidden]="! showBadge || num <= 0"
            aria-label="Devices view"
        >
            {{ icon }}
        </mat-icon> -->
        <span
            class="icon-badge-wrapper"
            [matBadge]="num"
            [matBadgeColor]="badgeColour"
            [matBadgePosition]="badgePosition"
            [matBadgeSize]="badgeSize"
            [matBadgeHidden]="!showBadge || num <= 0"
            aria-label="Devices view"
        >
            <mat-icon [ngClass]="showLabel ? '' : 'noLabel'" aria-hidden="true">
                {{ icon }}
            </mat-icon>
        </span>

        <span class="cdk-visually-hidden">{{ num }}</span>

        @if (showLabel) {
            <div class="sidebar-label">Devices</div>
        }

        @if (showExpansion) {
            <span>
                <mat-icon class="expansion-icon">chevron_right</mat-icon>
            </span>
        }
    </button>
</div>